module.exports = __webpack_public_path__ + "static/media/torch.eb35a4b2.png";